import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './Boot/App';
import createStore from './Boot/createStore';
import * as serviceWorker from './serviceWorker';
import './scss/styles.scss';
import './i18n';

const store = createStore();

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback="">
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
